const OMC_ENTITY = {
    ARTICOL: {
        key: "ARTICOL",
        textValue: "Articol"
    },
    PARTENER: {
        key: "PARTENER",
        textValue: "Partener"
    },
    CENTRU_DE_COST: {
        key: "CENTRU_DE_COST",
        textValue: "Centru de Cost"
    },
    PUNCT_DE_LUCRU: {
        key: "PUNCT_DE_LUCRU",
        textValue: "Punct de Lucru"
    },
    GRUPA_CHELTUIALA: {
        key: "GRUPA_CHELTUIALA",
        textValue: "Grupă Cheltuieli"
    },
    GRUPA_DOCUMENT: {
        key: "GRUPA_DOCUMENT",
        textValue: "Grupă Documente"
    },
    PROIECT: {
        key: "PROIECT",
        textValue: "Proiect"
    }
}

export default OMC_ENTITY;